import { render, staticRenderFns } from "./TopicAssistantResultIfram.vue?vue&type=template&id=44099434&scoped=true"
import script from "./TopicAssistantResultIfram.vue?vue&type=script&lang=js"
export * from "./TopicAssistantResultIfram.vue?vue&type=script&lang=js"
import style0 from "./TopicAssistantResultIfram.vue?vue&type=style&index=0&id=44099434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44099434",
  null
  
)

export default component.exports